// extracted by mini-css-extract-plugin
export default {"wrapper":"wo","form":"xo","checkbox":"yo","successWrapper":"zo","success":"Ao","successText":"Bo","circle":"Co","footnote":"Do","required":"Eo"};